module.exports = __webpack_public_path__ + "img/24_1.1ffdfadc.png";